<template>
    <router-link :to="{name: 'home'}">
      <img class="logoimg" src="./DataExpo.png" alt="">
      <!-- <span v-show="!hiddenHeaderRoute.includes($route.name)" class="datastore">Geoscience DataExpo</span> -->
      <!-- <img v-show="!hiddenHeaderRoute.includes($route.name)" src="./DataExpo.png" alt="" srcset="" width="80px"> -->
    </router-link>
</template>
<script>
export default {
    props: {
        color: {
            type: String,
            default: '#fff'
        }
    },
    data() {
    return {
      hiddenHeaderRoute: ['home'],
    }
  },
}
</script>
<style lang="less" scoped>
* {
  font-family: ddefont;
}
   .logo{
       
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
   }
   .logoimg{
       width: 90px;
       float: left;
       margin-left: 20px;
       margin-top: 5px;
   }
   .datastore{
       font-size: 30px;
       font-weight: bold;
       display: inline-block;
       margin-top: 10px;
       margin-left: 10px;
   }
</style>